/**
 * Mascaras de entrada.
 *
 * Aplicadas conforme o usuario digita; a validacao propriamente dita fica no Zod,
 * no `blur`. A mascara guia, o schema decide.
 */

type Mask = (raw: string) => string;

const onlyDigits = (value: string): string => value.replace(/\D/g, '');

/** `000.000.000-00` */
export const maskCpf: Mask = (raw) => {
  const d = onlyDigits(raw).slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/** `00.000.000/0000-00` */
export const maskCnpj: Mask = (raw) => {
  const d = onlyDigits(raw).slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

/** `00000-000` */
export const maskCep: Mask = (raw) => {
  const d = onlyDigits(raw).slice(0, 8);
  return d.replace(/^(\d{5})(\d)/, '$1-$2');
};

/** `(00) 0000-0000` ou `(00) 00000-0000`, conforme o tamanho. */
export const maskPhone: Mask = (raw) => {
  const d = onlyDigits(raw).slice(0, 11);
  if (d.length <= 10) {
    return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
  }
  return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
};

/** `dd/mm/aaaa` */
export const maskDate: Mask = (raw) => {
  const d = onlyDigits(raw).slice(0, 8);
  return d.replace(/^(\d{2})(\d)/, '$1/$2').replace(/^(\d{2})\/(\d{2})(\d)/, '$1/$2/$3');
};

/** `hh:mm` */
export const maskTime: Mask = (raw) => {
  const d = onlyDigits(raw).slice(0, 4);
  return d.replace(/^(\d{2})(\d)/, '$1:$2');
};

export const MASKS = {
  cpf: maskCpf,
  cnpj: maskCnpj,
  cep: maskCep,
  phone: maskPhone,
  date: maskDate,
  time: maskTime,
} as const;

export type MaskName = keyof typeof MASKS;

/** Remove tudo que nao for digito — o que vai para a API. */
export const unmask = onlyDigits;
